var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.99733,
    cy: 9.99733,
    rx: 9.79811,
    ry: 9.79811,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7992 9.99922C19.7992 11.9375 19.2245 13.8322 18.1476 15.4438C17.0708 17.0554 15.5402 18.3115 13.7495 19.0532C11.9588 19.795 9.98835 19.989 8.08734 19.6109C6.18632 19.2328 4.44013 18.2994 3.06958 16.9289C1.69902 15.5583 0.765662 13.8121 0.387527 11.9111C0.00939229 10.0101 0.203465 8.03963 0.945204 6.24892C1.68694 4.4582 2.94303 2.92765 4.55463 1.85082C6.16624 0.773978 8.06096 0.199219 9.99922 0.199219C12.5983 0.199219 15.091 1.23172 16.9289 3.06957C18.7667 4.90743 19.7992 7.40009 19.7992 9.99922ZM15.9037 8.23522C16.1203 8.01862 16.242 7.72486 16.242 7.41855C16.242 7.11224 16.1203 6.81848 15.9037 6.60188C15.6871 6.38529 15.3934 6.26361 15.0871 6.26361C14.7807 6.26361 14.487 6.38529 14.2704 6.60188L8.74155 12.1307L5.91589 9.31322C5.6993 9.09662 5.40553 8.97494 5.09922 8.97494C4.79291 8.97494 4.49915 9.09662 4.28256 9.31322C4.06596 9.52981 3.94428 9.82357 3.94428 10.1299C3.94428 10.4362 4.06596 10.73 4.28256 10.9465L8.73339 15.3974L15.9037 8.23522Z",
    fill: "#58B728"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTik);
export default __webpack_public_path__ + "static/media/GreenTik.8ad178065d319c452b84cb2f45dd4a30.svg";
export { ForwardRef as ReactComponent };